/**
 * 用户接口
 * 用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The ForgotPasswordSendCodeForm model module.
   * @module token/model/ForgotPasswordSendCodeForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>ForgotPasswordSendCodeForm</code>.
   * @alias module:token/model/ForgotPasswordSendCodeForm
   * @class
   * @param phone {String} 手机号
   */
  var exports = function(phone) {
    var _this = this;

    _this['phone'] = phone;
  };

  /**
   * Constructs a <code>ForgotPasswordSendCodeForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:token/model/ForgotPasswordSendCodeForm} obj Optional instance to populate.
   * @return {module:token/model/ForgotPasswordSendCodeForm} The populated <code>ForgotPasswordSendCodeForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'phone')) {
        obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
      }
    }
    return obj;
  }

  /**
   * 手机号
   * @member {String} phone
   */
  exports.prototype['phone'] = undefined;



  export default exports;
;


